import { NAVIGATION_ITEM_TYPE } from 'constants/navigation';

export const NAV_MIN_VISIBLE_ITEMS = 3;

export const OTHER_NAV_ITEM = {
  id: 'other-tab',
  title: 'Other',
  type: NAVIGATION_ITEM_TYPE.GROUP,
};
